import Box from '@mui/material/Box';
import LazyEditorSidebar from '../../components/editorSidebar/lazyEditorSidebar.jsx';

export default function LazyEditV2Endpoint(_props) {
  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <LazyEditorSidebar />
      <Box
        component="main"
        sx={{ flexGrow: 1, height: '100%', backgroundColor: '#1e1e1e' }}
      ></Box>
    </Box>
  );
}
